import { csx } from '@vtex/admin-ui'
import React, { useRef, useState } from 'react'
import { useIntl } from 'react-intl'

import { useWaitingList } from '../../hooks/useWaitingList'
import { InStoreList, InStoreListItem } from '../InStoreList'
import { List } from '../../shared/types'
import type { DragData } from '../../shared/types'
import { useInStoreLists } from '../../hooks/useInStoreLists'
import type { ListsItem } from '../../context/TurnListProvider'
import { usePositionsLists } from '../../states'
import { useShowArrows } from '../../hooks/useShowArrows'

export const WaitingList = () => {
  const { waitingPositions } = usePositionsLists()
  const { moveOutOfStoreItemToWaitingList } = useWaitingList()
  const intl = useIntl()
  const {
    moveInServiceListItemToWaitingList,
    moveWaitingListItemToInServiceList,
    getListTitle,
  } = useInStoreLists()

  const firstElementRef = useRef<HTMLDivElement>(null)
  const lastElementRef = useRef<HTMLDivElement>(null)
  const [showUpNavigation, setShowUpNavigation] = useState(false)
  const [showDownNavigation, setShowDownNavigation] = useState(false)

  const handleItemDrop = ({
    queueItem,
  }: DragData<ListsItem['inService'] | ListsItem['outOfStore']>) => {
    if (queueItem.kind === List.InService) {
      moveInServiceListItemToWaitingList(queueItem)
    } else if (queueItem.kind === List.OutOfStore) {
      moveOutOfStoreItemToWaitingList(queueItem)
    }
  }

  const handleWaitingItemClick = (
    clickedWaitingListItem: ListsItem['waiting'],
    clickedItemIndex: number
  ) => {
    const cutInLine = clickedItemIndex > 0

    moveWaitingListItemToInServiceList(cutInLine, clickedWaitingListItem)
  }

  useShowArrows({
    elementRef: firstElementRef,
    setShowNavigation: setShowUpNavigation,
    sellers: waitingPositions.length,
  })

  useShowArrows({
    elementRef: lastElementRef,
    setShowNavigation: setShowDownNavigation,
    sellers: waitingPositions.length,
  })

  return (
    <InStoreList
      className={csx({
        padding: '0rem 0.25rem 0.5rem 0.5rem',
        width: '100%',
      })}
      onItemDrop={handleItemDrop}
      title={getListTitle(
        intl.messages.waitingTurn as string,
        waitingPositions
      )}
      data-testid="waiting-list"
      dndAccept={[List.InService, List.OutOfStore]}
      showUpNavigation={showUpNavigation}
      showDownNavigation={showDownNavigation}
    >
      {waitingPositions.map((waitingListItem, index) => {
        const ref =
          index === 0
            ? firstElementRef
            : index === waitingPositions.length - 1
            ? lastElementRef
            : null

        return (
          <InStoreListItem
            ref={ref}
            key={waitingListItem.salesAssociate.id}
            index={index}
            item={waitingListItem}
            onClick={handleWaitingItemClick}
            dndType={List.Waiting}
            testId="waiting-list-item"
          />
        )
      })}
    </InStoreList>
  )
}
